<template lang="pug">

  section.banner
    a(href="http://208sessions.peugeot.cl/?ref=mtonline-peugeot")
      img(src="assets/images/banner.png", alt="Peugeot 208")

</template>

<script>
  export default  {
    name: 'banner',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .banner {
    position: relative;
    z-index: 3;
    a{
      display: block
    }
    img{
      display: block;
      max-width: 100%;
      margin-left: auto;
      margin-right: auto;
    }
  }
</style>
